import { cldResize } from "../../utils";
import React from "react";

// Cùng gradient với thanh header bên dưới (bg-gradient-to-r from-[#0a8279] via-[#0d9488] to-[#14b8a6])
// để dải 2 bên ngoài vùng an toàn 1240px liền mạch với header thay vì để trắng.
const HEALTHYMALL_GRADIENT = "linear-gradient(to right, #0a8279, #0d9488, #14b8a6)";

const TopBanner = ({ src, color }) => {
  // Nếu admin set màu riêng (khác trắng) thì tôn trọng; mặc định dùng gradient HealthyMall.
  const fill = color && color.toLowerCase() !== "white" ? color : HEALTHYMALL_GRADIENT;

  return (
    <div className='h-[50px]' style={{ background: fill }}>
      <div
        className='wide h-[50px]'
        style={{
          backgroundImage: `url(${cldResize(src, 1240)})`,
          backgroundPosition: "center",
          backgroundSize: "contain",
          backgroundRepeat: "no-repeat",
        }}
      ></div>
    </div>
  );
};

export default TopBanner;
